import NoMatchPage from './NoMatchPage'

export default NoMatchPage
